<template>
    <div class="exam-container">
        <headerPage></headerPage>

        <!-- 页面标题和搜索框 -->
        <div class="page-header">
            <div class="title-wrapper">
                <!-- 返回按钮 -->
                <el-page-header @back="goHome" class="return-button"></el-page-header>
                <h2 class="page-title">考试记录</h2>
            </div>
            <div class="header-right">
                <el-input v-model="searchQuery" placeholder="搜索试卷名称" prefix-icon="el-icon-search" clearable
                    class="search-input"></el-input>
            </div>
        </div>
        <div class="divider"></div>

        <!-- 考试记录展示 -->
        <div class="record-list">
            <el-row :gutter="20">
                <template v-if="total > 0">
                    <el-col v-for="(record, index) in recordList" :key="index" :xs="24" :sm="12" :md="8" :lg="6"
                        class="record-col">
                        <el-card class="record-card" shadow="hover">
                            <div class="record-info">
                                <p class="record-meta">
                                    {{ record.chapter ? record.course + ' / ' + record.chapter : record.course }}
                                </p>
                                <h3 class="record-title">{{ record.title }}</h3>
                                <p class="record-time">作答时间：{{ formatdoTime(record.doTime) }}</p>
                                <p class="record-time">提交时间：{{ record.submitTime }}</p>
                                <p class="record-score"
                                    :style="{ color: getScoreColor(record.acquireScore, record.score) }">
                                    得分：{{ record.acquireScore }} 分
                                </p>
                                <div class="record-footer">
                                    <el-button type="info" round size="mini"
                                        @click="handleViewReport(record.id)">查看报告</el-button>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </template>

                <!-- 无记录提示 -->
                <div v-else class="no-record">暂无考试记录</div>
            </el-row>

            <!-- 分页组件 -->
            <div class="pagination">
                <pagination v-show="total > 0" :hide-on-single-page="total > 0" :total="total"
                    :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize" @pagination="getList" />
            </div>
        </div>

        <bottomPage></bottomPage>
    </div>
</template>

<script>
import headerPage from "@/components/header/header";
import bottomPage from "@/components/bottom/bottom";

import * as PaperApi from "@/api/paper";

export default {
    components: {
        headerPage,
        bottomPage,
    },
    data() {
        return {
            searchQuery: "",
            recordList: [], // 所有记录
            total: 0,
            // 查询参数
            queryParams: {
                pageNo: 1,
                pageSize: 20,
                paperName: null,
            },
        };
    },
    watch: {
        searchQuery() {
            this.queryParams.pageNo = 1;
            this.queryParams.paperName = this.searchQuery;
            this.getList(); // 实时搜索
        },
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            const res = await PaperApi.getPaperAnswerRecordPage(this.queryParams);

            this.total = res.data.total;

            this.recordList = res.data.list.map(item => ({
                id: item.id,
                course: item.courseName,
                chapter: item.courseChapterName,
                title: item.paperName,
                doTime: item.doTime || 0,
                submitTime: this.formatTimestamp(item.createTime),
                acquireScore: item.acquireScore,
                score: item.score,
            }));

        },
        formatdoTime(seconds) {
            if (seconds === 0 || !seconds) return "暂无作答时间";
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${mins} 分钟 ${secs} 秒`;
        },
        formatTimestamp(ms) {
            const date = new Date(ms);
            const Y = date.getFullYear();
            const M = String(date.getMonth() + 1).padStart(2, "0");
            const D = String(date.getDate()).padStart(2, "0");
            const h = String(date.getHours()).padStart(2, "0");
            const m = String(date.getMinutes()).padStart(2, "0");
            const s = String(date.getSeconds()).padStart(2, "0");
            return `${Y}-${M}-${D} ${h}:${m}:${s}`;
        },
        getScoreColor(acquireScore, score) {
            if (acquireScore >= (score * 0.8)) return "#67c23a";
            if (acquireScore < (score * 0.6)) return "#f56c6c";
            return "#333";
        },
        handlePageChange(page) {
            this.currentPage = page;
        },
        handleViewReport(reportId) {
            // 示例跳转逻辑，按你项目的实际路由调整
            this.$router.push({
                name: 'paperReport', // 你的路由 name
                params: {
                    reportId: reportId,
                },
            });
        },
        // 返回首页
        goHome() {
            this.$router.push('/');
        }
    },
};
</script>

<style scoped>
.exam-container {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding: 20px;
}

.page-header {
    max-width: 1200px;
    margin: 20px auto 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title-wrapper {
    display: flex;
    align-items: center;
}

/* 调整返回按钮和标题之间的间距 */
.return-button {
    margin-top: 10px;
    margin-right: 10px;
}

.page-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.search-input {
    width: 240px;
}

.divider {
    width: 100%;
    height: 2px;
    background-color: #dcdfe6;
    margin: 10px auto 20px auto;
    max-width: 1200px;
}

.record-list {
    max-width: 1200px;
    margin: 0 auto;
}

.record-col {
    margin-bottom: 20px;
}

.record-card {
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.3s;
}

.record-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.record-info {
    padding: 14px;
}

.record-meta {
    font-size: 13px;
    color: #999;
    margin-bottom: 4px;
}

.record-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.record-time {
    font-size: 14px;
    font-weight: 400;
    color: #888;
    margin: 4px 0;
}

.record-score {
    font-size: 18px;
    font-weight: 600;
    margin-top: 20px;
    text-align: right;
}

.record-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.no-record {
    width: 100%;
    text-align: center;
    color: #bbb;
    font-size: 18px;
    padding: 60px 0;
}

.pagination {
    margin: 30px 0;
    text-align: center;
}
</style>
